export function loginFormValidations(value){

    let errors = {};
    if(!value.username){
        errors.username = 'Username is required';
    }
    if(!value.password){
        errors.password = 'Password is required';
    }
    return errors;


}

export function changePasswordForm(value){

    let errors = {};
    if(!value.currentPassword){
        errors.currentPassword = 'Current is required';
    }
    if(!value.newPassword){
        errors.newPassword = 'New Password is required';
    }
    if(!value.confirmPassword){
        errors.confirmPassword = 'Confirm Password is required';
    }
    return errors;


}

export function resetPasswordFormValidations(value){

    let errors = {};
    if(!value.email){
        errors.email = 'Email is required';
    }
    return errors;


}